import { render, staticRenderFns } from "./AssessmentTableInactive.vue?vue&type=template&id=9d40b24e"
import script from "./AssessmentTableInactive.vue?vue&type=script&lang=js"
export * from "./AssessmentTableInactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports